module.exports = "/_next/static/images/94a91e8541a877e1c29ea580c557ea36-hands-holding-cards-xs@3x.jpg";